export type GameState = 'idle' | 'running' | 'game-over';

export interface Sprite {
  image: HTMLImageElement;
  width: number;
  height: number;
  srcX?: number;
  srcY?: number;
  srcW?: number;
  srcH?: number;
}

export interface GameAssets {
  cone: Sprite;
  lamp: Sprite;
  plunger: Sprite;
  cart: Sprite;
}

export type ObstacleType = 'floor' | 'upper' | 'plunger' | 'cart';

export interface Obstacle {
  x: number;
  y: number;
  width: number;
  height: number;
  type: ObstacleType;
  speedMul?: number;
}

export interface Player {
  x: number;
  y: number;
  width: number;
  height: number;
  velocityY: number;
  isJumping: boolean;
  isDucking: boolean;
}

export const GameConfig = {
  CANVAS_WIDTH: 1000,
  CANVAS_HEIGHT: 300,
  GROUND_Y: 240,
  FLOOR_HEIGHT: 60,
  GRAVITY: 0.7,
  JUMP_FORCE: -13,
  INITIAL_SPEED: 5,
  MAX_SPEED: 15,
  SPEED_INCREMENT: 0.00125,
  MIN_OBSTACLE_GAP: 375,
  PLAYER_X: 60,
  PLAYER_SIZE: 48,
  DUCK_HEIGHT: 26,
  CONE_WIDTH: 36,
  CONE_HEIGHT: 48,
  LAMP_WIDTH: 48,
  LAMP_HEIGHT: 66,
  LAMP_HANG_Y: 0,
  PLUNGER_WIDTH: 72,
  PLUNGER_HEIGHT: 28,
  PLUNGER_Y: 180,
  PLUNGER_SPEED_MUL: 1.5,
  PLUNGER_SPAWN_CHANCE: 0.2,
  CART_WIDTH: 100,
  CART_HEIGHT: 50,
  CART_SPEED_MUL: 1.6,
  CART_SPAWN_CHANCE: 0.3,
  CART_COOLDOWN_MS: 2500,
  SCORE_PER_FRAME: 0.15,
  HIGH_SCORE_KEY: 'tinct-game-high-score',
  COLLISION_INSET: 7,
  TARGET_FRAME_TIME: 1000 / 60,
  MAX_DELTA_FACTOR: 3,
  CHARACTER_FILES: ['bird.gif', 'bird2.gif', 'bird3.gif'] as const,
} as const;
